<template>
    <form>
        <b-modal :active.sync="isComponentModalActive"
                 :full-screen.sync="isFullScreen"
                 has-modal-card  >

            <div class="modal-card ">
                <header class="modal-card-head"  >





                    <div class='rows'>
<!--                        <div class='row is-full'>-->
<!--                            <b-field grouped >-->
<!--                                <b-field label="Date Kind">-->
<!--                                </b-field>-->
<!--                                <b-field label="Date Kind">-->
<!--                                </b-field>-->
<!--                            </b-field>-->
<!--                        </div>-->
                        <div class='row is-full'>
                            <b-field grouped >

                            <b-field label="Date Kind">
                                <b-select placeholder="Select Date Kind" v-model="dateKindsSelected">
                                    <option
                                            v-for="dateKind in dateKinds"
                                            :value="dateKind.id"
                                            :key="dateKind.id">
                                        {{ dateKind.name }}
                                    </option>
                                </b-select>
                            </b-field>
<!--                                 v-model="date_selected" -->

                            <b-field label="Start Date">
                                <b-datepicker
                                              :date-formatter="dateFormatterForDatePicker"
                                              v-model="date_selectedStart"
                                              placeholder="Click to select..."
                                              icon="calendar-today"
                                >
                                </b-datepicker>
                                <b-tooltip label="Set Today" position="is-top">
                                <p class="control">
                                    <b-button type="is-success" icon-left="close"  outlined  @click="clearSomeField('date_selected_start')"/>
                                </p>
                                </b-tooltip>
                            </b-field>




                            <b-field label="Due Date">
                                <b-datepicker
                                        :date-formatter="dateFormatterForDatePicker"
                                        v-model="date_selectedDue"
                                        placeholder="Click to select..."
                                        icon="calendar-today"
                                >
                                </b-datepicker>
                                <b-tooltip label="Set Today" position="is-top">
                                    <p class="control">
                                        <b-button type="is-success" icon-left="close"  outlined  @click="clearSomeField('date_selected_due')"/>
                                    </p>
                                </b-tooltip>
                            </b-field>



                            <b-field label="OPD No."
                                     :type="{ 'is-danger': hasErrorAllFieldBlank }"
                                     :message="{ 'please some input to search': hasErrorAllFieldBlank }"
                            >
<!--                                <b-input   v-model="OPDNo" placeholder="» » » » 63000001 « « « «"-->

<!--                                ></b-input>-->
                                <b-input   :value="OPDNo" @change.native="OPDNo = $event.target.value" placeholder="» » » » 63000001 « « « «"
                                ></b-input>
                                <b-tooltip label="Clear OPD No." position="is-top">
                                <p class="control">
                                    <b-button type="is-success" icon-left="close"  outlined  @click=" OPDNo= '' "   />
                                </p>
                                </b-tooltip>
                            </b-field>


                            <b-field label="Pet Name"
                                     :type="{ 'is-danger': hasErrorAllFieldBlank }"
                                     :message="{ 'please some input to search': hasErrorAllFieldBlank }"  >
<!--                                <b-input v-model="petName"  placeholder="» » » » » » แดง « « « « « «"-->
<!--                                ></b-input>-->
                                <b-input   :value="petName" @change.native="petName = $event.target.value"  placeholder="» » » » » » แดง « « « « « «"
                                ></b-input>
                                <b-tooltip label="Clear Pet Name" position="is-top">
                                <p class="control">
                                    <b-button type="is-success" icon-left="close"  outlined  @click=" petName = '' " />
                                </p>
                                </b-tooltip>
                            </b-field>


                             <b-field label="Owner Name"
                                         :type="{ 'is-danger': hasErrorAllFieldBlank }"
                                         :message="{ 'please some input to search': hasErrorAllFieldBlank }"  >
<!--                                    <b-input v-model="ownerName"  placeholder="» » » » » » สมหญิง « « « « « «"-->
<!--                                    ></b-input>-->
                                 <b-input   :value="ownerName" @change.native="ownerName = $event.target.value"  placeholder="» » » » » » สมหญิง « « « « « «"></b-input>
                                 <b-tooltip label="Clear Owner Name" position="is-top">
                                 <p class="control">
                                     <b-button type="is-success" icon-left="close"  outlined @click=" ownerName = '' " />
                                 </p>
                                 </b-tooltip>
                             </b-field>



                            <b-field label="Search">
                                <b-button type="is-success" icon-left="magnify"  outlined @click="searchCompleteOrderList" :disabled="isFullScreenSearching || !$v.OPDNo.maxLength"  ref="btnSearch"  ></b-button>
                            </b-field>


                            <b-field label="Clear All">
                                <b-button type="is-danger" icon-left="close"  outlined @click="initDat"   ref="btnClearAll"  ></b-button>
                            </b-field>




                        </b-field>
                        </div>
                        <div class='row is-full'>
                            <b-message type="is-danger" v-if="!$v.OPDNo.maxLength">
                            Error max length for OPD no. are 8 char
                            </b-message>

                            <b-message type="is-danger" v-if="!$v.OPDNo.integer">
                                Error   OPD no. must be numberic (not character)
                            </b-message> </div>
                    </div>





                </header>
                <section class="modal-card-body"  >
                    <!-- Content ... -->
                    <b-loading  :active.sync="isFullScreenSearching" ></b-loading>





                    <b-table
                            :data= "isEmpty ? []  : completedOrdersList"
                            bordered
                            striped
                            hoverable
                            paginated
                            :per-page="perPage"
                            :current-page.sync="currentPage"
                    >
<!--                        :loading="isTblLoading"-->

                            <b-table-column  label="LAB Order No."  centered v-slot="props">
                               {{ props.row.idlaborder }}
                            </b-table-column>
                            <b-table-column  label="OPD No."  centered v-slot="props">
                                {{ props.row.opd_no }}
                            </b-table-column>
                            <b-table-column  label="Pet Name"  centered v-slot="props">
                                {{ props.row.opd_name }}
                            </b-table-column>
                            <b-table-column  label="Owner Name"  centered v-slot="props">
                                {{ props.row.owner_name }}
                            </b-table-column>
                            <b-table-column  label="DateTime req."  centered v-slot="props">
                                {{customFormatDateF(props.row.date_rec)}} - {{props.row.time_rec}}
                            </b-table-column>
                            <b-table-column  label="User rec."  centered v-slot="props">
                                {{ props.row.user_rec_name }}
                            </b-table-column>
                            <b-table-column  label="Group request"  centered v-slot="props">
                                {{ props.row.grp_name }}
                            </b-table-column>
                            <b-table-column  label="DateTime deleted"  centered v-slot="props">

                                {{ customFormatDateF(props.row.date_deleted) }} -  {{ props.row.time_deleted }}
                            </b-table-column>
                            <b-table-column  label="User deleted"  centered v-slot="props">
                                {{ props.row.user_delete_name }}
                            </b-table-column>
                            <b-table-column  label="Reason to delete"  centered v-slot="props">
                                {{ props.row.delete_reason }}
                            </b-table-column>
                            <b-table-column  label="Re Assign"  centered v-slot="props">
                                <b-button type="is-info" @click="showAssignJob(props.row)">Re Assign</b-button>
                            </b-table-column>




                        <template slot="empty">
                            <section class="section">
                                <div class="content has-text-grey has-text-centered">
                                    <p>
                                        <b-icon
                                                icon="table-search"
                                                size="is-large">
                                        </b-icon>
                                    </p>
                                    <p>Nothing here.</p>
                                </div>
                            </section>
                        </template>


<!--                        <template slot="footer"  >-->
<!--                            <div class="box">-->
<!--                                <div  class="level-left" >    </div>-->
<!--                                <div  class="level-right" >    <b-button type="is-primary" outlined v-show="opdListResultSearch.length>0"   :disabled="isDisableMoreBtn" :loading="isMoreBtnLoading" @click="doFilter('m')"  >More..</b-button></div>-->
<!--                            </div>-->
<!--                        </template>-->


                    </b-table>

                    <AssignedJob v-if="isAssignedJob" @close="closeDlgAssignedJob"   :dataToChild="rowSelected"  :isShowAssignedJob="isAssignedJob"></AssignedJob>
                </section>
                <footer class="modal-card-foot">

                    <b-button type="is-danger"
                              icon-left="close"  @click="closeModal"   >
                        Close
                    </b-button>


                </footer>
            </div>

        </b-modal>
    </form>
</template>

<script>
    /* eslint-disable no-console */
    import {integer, maxLength} from "vuelidate/lib/validators";
    import axios from "axios";
    import { customFormatDate , getBaseURLforBackEnd , getConfigAxios}  from '@/utils.js'
    import moment from "moment";
    import AssignedJob from "./AssignedJob"
    import findDiffDate from "../../mixins/methods/findDiffDate";
    import dateFormatterForDatePicker from "../../mixins/methods/dateFormatterForDatePicker";
    import { mapState } from "vuex";

    export default {
        name: "CompletedOrders",
        components :{
            AssignedJob
        },
        mixins:[findDiffDate , dateFormatterForDatePicker],
        computed:{
             ...mapState({
                access_token: state => state.master_data.access_token,
            })

        },
        mounted() {
            this.loadCurrentDate(2)
        },
        methods:{
            clearSomeField(fieldWantToClear){
                switch(fieldWantToClear) {
                    case 'date_selected_start':
                        this.loadCurrentDate(0)
                        break;
                    case 'date_selected_due':
                        this.loadCurrentDate(1)
                        break;
                    case 'OPDNo':
                        this.OPDNo = ""
                        break;
                    case 'petName':
                        this.petName = ""
                        break;
                    case 'ownerName':
                        this.ownerName = ""
                        break;
                    default:
                        break;
                }
            },
            closeDlgAssignedJob(){
                this.isAssignedJob = false
            },
            showAssignJob(row){
                this.rowSelected = row
                if(this.rowSelected) {
                    this.isAssignedJob = true
                }
            },
            customFormatDateF(dat){
                return customFormatDate(dat)
            },
            loadCurrentDate(type_){
                const vm = this
                axios.get(`${getBaseURLforBackEnd()}/api/curdatetime` ,getConfigAxios())
                    .then( response => {
                        // console.log(type_)
                        // vm.date_selectedStart = new Date(response.data.current_datetime)
                        // vm.date_selectedDue = new Date(response.data.current_datetime)
                        if(type_ === 0){
                            vm.date_selectedStart = new Date(response.data.current_datetime)
                        }else if(type_ === 1){
                            vm.date_selectedDue = new Date(response.data.current_datetime)
                        }else {
                            vm.date_selectedStart = new Date(response.data.current_datetime)
                            vm.date_selectedDue = new Date(response.data.current_datetime)
                        }

                    })
                    .catch((error)=>{
                        // console.log(error)
                        vm.$buefy.toast.open({
                            duration: 500,
                            message:  `${error}`,
                            position: 'is-bottom',
                            type: 'is-warning'
                        })
                    })
      
            },
            closeModal(){
                this.isComponentModalActive = false
            },
            initDat(){
                this.loadCurrentDate()
                this.hasErrorAllFieldBlank = false,
                this.hasErrorHomeAddressFieldBlank = false
                this.completedOrdersList = []
                this.ownerName = ''
                this.petName = ''
                this.ownersurname = ''
                this.OPDNo = ''

            },


            searchCompleteOrderList(){
 


                // check date
                const daysDiff = this.findDiffDate(this.date_selectedStart,this.date_selectedDue)
                if(daysDiff>31 || daysDiff<0 ){
                    var alarmTxt =   ` `
                    if (daysDiff<0){
                        alarmTxt =   `start date less than due date `
                    }
                    if(daysDiff>31){
                        alarmTxt =   `date over 31 day `
                    }
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: ` Invalid date selected at  ${alarmTxt}  =>  user select at  ${daysDiff}  day`,
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                    return
                }




                    const datTo = {
                        "date_selected": [moment(this.date_selectedStart).format("YYYY-MM-DD"), moment(this.date_selectedDue).format("YYYY-MM-DD")],
                        "dat_kind": this.dateKindsSelected,
                        "user_rec": this.user_rec,
                        "opdname": this.petName,
                        "ownername": this.ownerName,
                        "opdno": this.OPDNo
                    }

                    // console.log(JSON.stringify(datTo))
                    const vm = this
                    this.isFullScreenSearching = true
                    axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                    axios.post(`${getBaseURLforBackEnd()}/api/orderlablistcompleted`, datTo, getConfigAxios())
                        .then((res) => {
                            // console.log( res.data)
                            vm.completedOrdersList = res.data
                            setTimeout(()=>{
                                vm.isFullScreenSearching = false
                            },1000)

                        })
                        .catch(error => {
                            // console.log(err)
                            vm.isFullScreenSearching = false
                            vm.$buefy.toast.open({
                                duration: 5000,
                                message: `Some error to ${error}`,
                                position: 'is-top',
                                type: 'is-danger'
                            })

                            if (error.response && error.response.status === 401) {
                                vm.$router.push('/login')
                            }


                        })





                }

                

        },
        validations:{
            OPDNo :{
                maxLength :   maxLength(8),
                integer
            }
        },
        data(){
            return {
                isComponentModalActive : false,
                isFullScreen : true,
                hasErrorAllFieldBlank : false,
                isFullScreenSearching : false,
                completedOrdersList : [] ,
                isEmpty: false,
                rowSelected : null ,
                isAssignedJob: false,


                // v-model
                // date_selected:[],
                date_selectedStart : null,
                date_selectedDue : null,
                user_rec : "" ,
                OPDNo : "",
                petName : "",
                ownerName : "",

                //
                dateKinds : [{"id":1 ,name:"Date Request"},{"id":2 ,name:"Date Deleted"}],
                dateKindsSelected : 1,

                //
                perPage : 50,
                currentPage : 1

            }
        }
    }
</script>

<style scoped>
    .rows{
        display: flex;
        flex-direction: column;
    }
</style>